export const previewPendingActionItems = {
  "1774623815987-86781-LNymX-item-actionitem": {
    "id": "1774623815987-86781-LNymX-item-actionitem",
    "quantity": 1,
    "inputText": "I would like to use it during lunch today.",
    "status": "pending",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Item Used",
    "playerId": "1772165586781-LNymXRI-game_JSx4p6pOdtEAGMvzmX3AcbwT",
    "elementId": "1772230537871-86781-LNymX-item",
    "elementDocNum": null,
    "ts": 1774623815987,
    "path": "a9y-y7l0nz1q2h9arn",
    "ts_submitted": 1774623815987,
    "type": "item"
  },
  "1774818340234-86781-LNymX-challenge-actionitem": {
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "elementId": "1772569886040-86781-LNymX-challenge",
    "inputText": "I read \"The Mystery of the Ghost Ship Mary Celeste\" (Historical Archive Article)\n\nBasically, ,in 1872, a ship was found floating in the Atlantic with its entire crew missing but the cargo and supplies completely untouched. Numerous theories have been proposed, ranging from pirate attacks to underwater earthquakes, but no one has ever found a trace of the sailors. The mystery remains one of the most famous \"cold cases\" in maritime history. This connects to our Intro to Rhetoric unit because the article uses \"Logos\" to debunk the crazier theories (like sea monsters) by showing that there was no physical damage to the ship’s hull.",
    "status": "pending",
    "gameId": "1772165586781-LNymXRI-game",
    "event": "Challenge Submitted",
    "upload": false,
    "id": "1774818340234-86781-LNymX-challenge-actionitem",
    "fileName": null,
    "file": null,
    "type": "challenge",
    "fileType": null,
    "ts_submitted": 1774818340234,
    "path": "0eudpi_et8pwey021h",
    "elementDocNum": null,
    "ts": 1774818340234
  }
}

export const previewCompleteActionItems = {
  "1774498029778-86781-LNymX-challenge-actionitem": {
    "fileType": null,
    "approval_name": "Adam @ Gamably",
    "file": null,
    "event": "Challenge Submitted",
    "path": "7_6s9wx7_11r1mi29g",
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "type": "challenge",
    "id": "1774498029778-86781-LNymX-challenge-actionitem",
    "gameId": "1772165586781-LNymXRI-game",
    "comments": "Excellent video!",
    "ts": 1774498047500,
    "quantity": null,
    "inputText": "I shared my video with you in Google Classroom",
    "elementId": "1772569770551-86781-LNymX-challenge",
    "upload": false,
    "elementDocNum": null,
    "activityRecordId": "1774498048484-OKBBAo2RM44OS9DjaPrHxwrU-approvedChallenge",
    "ts_submitted": 1774498029778,
    "status": "approved",
    "approval_appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "approval_ts": 1774498048484,
    "fileName": null
  },
  "1774501243641-86781-LNymX-challenge-actionitem": {
    "ts": 1774501435041,
    "comments": "Well done!",
    "type": "challenge",
    "id": "1774501243641-86781-LNymX-challenge-actionitem",
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "gameId": "1772165586781-LNymXRI-game",
    "path": "ctwn2fw842dzk6e7dk",
    "file": null,
    "event": "Challenge Submitted",
    "approval_name": "Adam @ Gamably",
    "status": "approved",
    "approval_appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "approval_ts": 1774501436178,
    "fileName": null,
    "elementDocNum": null,
    "activityRecordId": "1774501436178-OKBBAo2RM44OS9DjaPrHxwrU-approvedChallenge",
    "ts_submitted": 1774501243641,
    "upload": false,
    "quantity": null,
    "inputText": "I have uploaded my Character Map.",
    "elementId": "1772572118651-86781-LNymX-challenge"
  },
  "1774535538361-86781-LNymX-challenge-actionitem": {
    "status": "approved",
    "approval_ts": 1774572338000,
    "approval_appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "activityRecordId": "1774572338000-ZvZ0CMN6ywykvdvTHuOPvRKz-approvedChallenge",
    "elementDocNum": null,
    "ts_submitted": 1774535538361,
    "quantity": null,
    "inputText": "I read \"The Last Question\" by Isaac Asimov. The story follows a supercomputer named Multivac over trillions of years as humans repeatedly ask if the universe's eventual death can be reversed. As humanity evolves and merges with the computer, the universe finally goes dark and cold. In the end, the computer figures out the answer and creates a brand-new universe with a single command.",
    "elementId": "1772569886040-86781-LNymX-challenge",
    "ts": 1774572336346,
    "comments": "Great summary! I hope you enjoy the book!",
    "id": "1774535538361-86781-LNymX-challenge-actionitem",
    "type": "challenge",
    "playerId": "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
    "gameId": "1772165586781-LNymXRI-game",
    "path": "fjuuhofkhefkouo7xb",
    "event": "Challenge Submitted",
    "approval_name": "Adam @ Gamably"
  },
  "1774571645810-86781-LNymX-challenge-actionitem": {
    "fileType": null,
    "approval_name": "Adam @ Gamably",
    "file": null,
    "event": "Challenge Submitted",
    "path": "c_chjwqqonm55wh2-m",
    "playerId": "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
    "type": "challenge",
    "id": "1774571645810-86781-LNymX-challenge-actionitem",
    "gameId": "1772165586781-LNymXRI-game",
    "comments": "Great prophecy! That's a fantastic novel.",
    "ts": 1774572420497,
    "quantity": null,
    "inputText": "Of Mice and Men by John Steinbeck\nMy prophecy is that George is going to end up alone and really sad because he keeps having to fix all the problems Lennie makes. Since he already told Lennie to hide in the brush if things go bad, I think something terrible is going to happen at the new ranch soon. He will probably have to give up on the dream of the farm with the rabbits because they never stay in one place long enough to save money.",
    "elementId": "1772569834612-86781-LNymX-challenge",
    "upload": false,
    "elementDocNum": null,
    "activityRecordId": "1774572421960-2Vo46bD7t6SWCo7PN9MPZME5-approvedChallenge",
    "ts_submitted": 1774571645810,
    "status": "approved",
    "approval_ts": 1774572421960,
    "approval_appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "fileName": null
  },
  "1774571686524-86781-LNymX-challenge-actionitem": {
    "path": "-p7vm42mwh-qdrour1",
    "fileType": null,
    "event": "Challenge Submitted",
    "file": null,
    "approval_name": "Adam @ Gamably",
    "ts": 1774572433193,
    "comments": "Excellent!",
    "id": "1774571686524-86781-LNymX-challenge-actionitem",
    "type": "challenge",
    "playerId": "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
    "gameId": "1772165586781-LNymXRI-game",
    "upload": false,
    "inputText": "I uploaded my video",
    "quantity": null,
    "elementId": "1772569770551-86781-LNymX-challenge",
    "status": "approved",
    "fileName": null,
    "approval_ts": 1774572434610,
    "approval_appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2",
    "elementDocNum": null,
    "activityRecordId": "1774572434610-2Vo46bD7t6SWCo7PN9MPZME5-approvedChallenge",
    "ts_submitted": 1774571686524
  },
  "1774536340963-86781-LNymX-challenge-actionitem": {
    "fileType": null,
    "approval_name": "Adam @ Gamably",
    "event": "Challenge Submitted",
    "file": null,
    "path": "-xp0vkrsxxb0dvv4ne",
    "playerId": "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
    "id": "1774536340963-86781-LNymX-challenge-actionitem",
    "type": "challenge",
    "gameId": "1772165586781-LNymXRI-game",
    "comments": "Sorry, that didn't meet the requirements. Try again and upload your new video. Be sure to focus on emulating the way we think Romans would have sounded based on your reading.",
    "ts": 1774572402360,
    "inputText": "I uploaded my video.",
    "quantity": null,
    "elementId": "1772569770551-86781-LNymX-challenge",
    "upload": false,
    "elementDocNum": null,
    "activityRecordId": "1774572403947-ZvZ0CMN6ywykvdvTHuOPvRKz-declinedChallenge",
    "ts_submitted": 1774536340963,
    "status": "declined",
    "fileName": null,
    "approval_ts": 1774572403947,
    "approval_appId": "LNymXRIM2ASSsSrLza6lfvWLXKz2"
  }
}